import { lazy } from 'react'

import { createBrowserRouter } from 'react-router-dom'

import Partner from 'pages/PayCms/MasterTables/Partner'
import resources from 'utils/constants/resources'

const Subscription = lazy(
  () => import('pages/AccountManagement/AttachSubscription/Bulk')
)
const AccountCouponStatus = lazy(
  () => import('pages/PayCms/Coupons/CouponStatus')
)
const GuestOrderDetails = lazy(
  () => import('pages/AccountManagement/GuestOrderDetails')
)
const InApp = lazy(() => import('pages/AccountManagement/Inapp'))
const RegisterUser = lazy(() => import('pages/AccountManagement/Users/Create'))
const SearchByUser = lazy(
  () => import('pages/AccountManagement/Users/UserInfo')
)
const UserDetails = lazy(() => import('pages/AccountManagement/Users/View'))
const OrderDetails = lazy(
  () => import('pages/AccountManagement/Users/View/Order/Detail')
)
const Country = lazy(() => import('pages/PayCms/MasterTables/Country'))
const Mapping = lazy(() => import('pages/PayCms/MasterTables/Mapping'))
const Platform = lazy(() => import('pages/PayCms/MasterTables/Platform'))
const Product = lazy(() => import('pages/PayCms/MasterTables/Product'))
const Provider = lazy(() => import('pages/PayCms/MasterTables/Provider'))
const PaymentMode = lazy(() => import('pages/PayCms/MasterTables/PaymentMode'))
const Reports = lazy(() => import('pages/PayCms/Reports/Reports'))
const ProtectedRoute = lazy(() => import('./protectedRoute'))
const LandingPage = lazy(() => import('pages/LandingPage'))
const PageNotFound = lazy(() => import('pages/PageNotFound'))
const ProfilePage = lazy(() => import('pages/ProfilePage'))
const ErrorBoundary = lazy(() => import('components/ErrorBoundary'))
const DashboardLayout = lazy(() => import('layouts/Dashboard'))
const AccessDenied = lazy(() => import('pages/AccessDeniedPage'))
const AccountSearch = lazy(() => import('pages/AccountManagement'))
const Plans = lazy(() => import('pages/PayCms/Plans'))
const CreatePlan = lazy(() => import('pages/PayCms/Plans/Create'))
const ViewPlan = lazy(() => import('pages/PayCms/Plans/View'))
const ViewOffer = lazy(() => import('pages/PayCms/Combos/View'))
const OfferList = lazy(() => import('pages/PayCms/Combos/List'))
const Create = lazy(() => import('pages/PayCms/Coupons/Create'))
const Coupons = lazy(() => import('pages/PayCms/Coupons/List'))
const ViewCoupon = lazy(() => import('pages/PayCms/Coupons/View'))
const CouponReports = lazy(() => import('pages/PayCms/Coupons/Reports'))
const CreateTranslation = lazy(() => import('pages/PayCms/Translations/Create'))
const Translations = lazy(() => import('pages/PayCms/Translations/List'))
const Extract = lazy(() => import('pages/PayCms/Reports/ExtractPlans'))
const CreateOffer = lazy(() => import('pages/OfferManagement/Create/index'))
const OfferManagement = lazy(() => import('pages/OfferManagement/index'))
const CreateComboOffer = lazy(() => import('pages/PayCms/Combos/Create/index'))
const ViewOfferMngt = lazy(() => import('pages/OfferManagement/View'))
const Apple = lazy(() => import('pages/AccountManagement/Inapp/Apple'))
const Deeplink = lazy(() => import('pages/Creatives/Deeplink'))
const ViewDeeplink = lazy(() => import('pages/Creatives/Deeplink/View/index'))
const CreateDeeplink = lazy(() => import('pages/Creatives/Deeplink/Create'))

export const routes = [
  {
    path: '/',
    element: <LandingPage />,
  },
  {
    path: '/',
    element: <DashboardLayout />,
    errorElement: <ErrorBoundary />,
    children: [
      {
        path: resources.PROFILE.path,
        element: <ProfilePage />,
      },
      {
        path: resources.ACCOUNT_MGMT.USERS.INFO.path,
        element: <SearchByUser />,
      },
      {
        path: resources.ACCOUNT_MGMT.USERS.path,
        element: <AccountSearch />,
      },
      {
        path: resources.ACCOUNT_MGMT.USERS.USERS_INFO.path,
        element: <UserDetails />,
      },
      {
        path: resources.ACCOUNT_MGMT.USERS.REGISTER.path,
        element: <RegisterUser />,
      },
      {
        path: resources.ACCOUNT_MGMT.USERS.ORDER_DETAILS.path,
        element: <OrderDetails />,
      },
      {
        path: resources.ACCOUNT_MGMT.IN_APP_SUBSCRIPTION.OTHERS.path,
        element: <InApp />,
      },
      {
        path: resources.ACCOUNT_MGMT.IN_APP_SUBSCRIPTION.APPLE.path,
        element: <Apple />,
      },
      {
        path: resources.ACCOUNT_MGMT.GUEST_SUBSCRIPTION.path,
        element: <GuestOrderDetails />,
      },
      {
        path: resources.PAY_CMS.COUPONS.STATUS.path,
        element: <AccountCouponStatus />,
      },
      {
        path: resources.ACCOUNT_MGMT.COUPON_STATUS.path,
        element: <AccountCouponStatus />,
      },
      {
        path: resources.ACCOUNT_MGMT.ATTACH_SUBSCRIPTION.path,
        element: <Subscription />,
      },
      {
        path: resources.PAY_CMS.PLANS.path,
        element: <Plans />,
      },
      {
        path: resources.PAY_CMS.PLANS.CREATE.path,
        element: <CreatePlan />,
      },
      {
        path: resources.PAY_CMS.PLANS.EDIT.path,
        element: <CreatePlan isEdit />,
      },
      {
        path: resources.PAY_CMS.PLANS.VIEW.path,
        element: <ViewPlan />,
      },
      {
        path: resources.PAY_CMS.OFFERS.CREATE.path,
        element: <CreateComboOffer />,
      },

      {
        path: resources.PAY_CMS.OFFERS.path,
        element: <OfferList />,
      },
      {
        path: resources.PAY_CMS.OFFERS.VIEW.path,
        element: <ViewOffer />,
      },
      {
        path: resources.PAY_CMS.COUPONS.LIST.path,
        element: <Coupons />,
      },
      {
        path: resources.PAY_CMS.COUPONS.CREATE.path,
        element: <Create />,
      },
      {
        path: resources.PAY_CMS.COUPONS.VIEW.path,
        element: <ViewCoupon />,
      },
      {
        path: resources.PAY_CMS.COUPONS.REPORTS.path,
        element: <CouponReports />,
      },
      {
        path: resources.PAY_CMS.TRANSLATIONS.CREATE.path,
        element: <CreateTranslation />,
      },
      {
        path: resources.PAY_CMS.TRANSLATIONS.path,
        element: <Translations />,
      },
      {
        path: resources.PAY_CMS.REPORTS.TRANSACTIONS.path,
        element: <Reports />,
      },
      {
        path: resources.PAY_CMS.REPORTS.EXTRACT_PLANS.path,
        element: <Extract />,
      },
      { path: resources.PAY_CMS.MASTER.PRODUCT.path, element: <Product /> },
      {
        path: resources.PAY_CMS.MASTER.PARTNER.path,
        element: <Partner />,
      },
      {
        path: resources.PAY_CMS.MASTER.PLATFORM.path,
        element: <Platform />,
      },
      {
        path: resources.PAY_CMS.MASTER.COUNTRY.path,
        element: <Country />,
      },
      {
        path: resources.PAY_CMS.MASTER.PROVIDER.path,
        element: <Provider />,
      },
      {
        path: resources.PAY_CMS.MASTER.PAYMENT_MODE.path,
        element: <PaymentMode />,
      },
      {
        path: resources.PAY_CMS.MASTER.MAPPING.path,
        element: <Mapping />,
      },
      {
        path: resources.OFFER_MGMT.basePath,
        element: <OfferManagement />,
      },
      {
        path: resources.OFFER_MGMT.CREATE.path,
        element: <CreateOffer />,
      },
      {
        path: resources.OFFER_MGMT.EDIT.path,
        element: <CreateOffer editing />,
      },
      {
        path: resources.OFFER_MGMT.VIEW.path,
        element: <ViewOfferMngt />,
      },
      {
        path: resources.CREATIVES.DEEPLINK.path,
        element: <Deeplink />,
      },
      {
        path: resources.CREATIVES.DEEPLINK.VIEW.path,
        element: <ViewDeeplink />,
      },
      {
        path: resources.CREATIVES.DEEPLINK.CREATE.path,
        element: <CreateDeeplink />,
      },
      {
        path: resources.CREATIVES.DEEPLINK.EDIT.path,
        element: <CreateDeeplink isEdit />,
      },
    ],
  },
  {
    path: resources.PAGE_NOT_FOUND.path,
    element: <PageNotFound />,
  },
  {
    path: resources.ACCESS_DENIED.path,
    element: <AccessDenied />,
  },
  {
    path: '*',
    element: <PageNotFound />,
  },
]

const Routes = createBrowserRouter([
  ...routes.map((route) => ({
    ...route,
    element: <ProtectedRoute element={route.element} />,
  })),
])

export default Routes
